/*
 * © 2026 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */

export const SAMPLE_RATES = [
  "Default",
  "Raw",
  "Hour",
  "Day",
  "Week",
  "Month",
] as const;

export type SampleRateType = (typeof SAMPLE_RATES)[number];

export const DEFAULT_SAMPLE_RATE: SampleRateType = "Default";

/** Case-insensitively matches a value to a supported sample rate, falling back to "Default". */
export const matchSampleRate = (value: unknown): SampleRateType => {
  if (typeof value !== "string") return DEFAULT_SAMPLE_RATE;
  const normalised = value.trim().toLowerCase();
  return (
    SAMPLE_RATES.find((rate) => rate.toLowerCase() === normalised) ??
    DEFAULT_SAMPLE_RATE
  );
};
